import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  GrantPrimaryButtonWrapper,
  ButtonWrapper,
  Spinner,
  FlowButtonContainer,
} from '../../style';
import { PrimaryButtonComponent } from '../../../../../../CommonComponents/commonStyles';
import DrupalPopup from '../Popup/DrupalPopup';
import { GeneralButton } from '../../../../../../CommonComponents/Commons/commonComponents';
function FlowFooter({
  primaryCtaLabel = 'Next',
  handlePrimaryCta,
  secondaryCtaLabel = 'Back',
  handleSecondaryCta,
  exitCtaLabel = 'Exit',
  handleExitCta,
  showExitCta = true,
  enablePrimary = true,
  enableUpdate = true,
  edit = false,
  spin = false,
  handleUpdateCancel,
  updateCancelLabel = 'Cancel Edit',
  handleUpdateCta,
  updateCtaLabel = 'Update',
  enableCancelPopUp = false,
  exitPrimaryCtaLabel = 'CONTINUE',
  exitSecondaryCtaLabel = 'No, take me back',
  cancelFitWidth,
  page,
  keyProperty,
  keyPropertyUpdate,
}) {
  const [showExitPopup, setShowExitPopup] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const showExitModal = () => (
    <>
      <DrupalPopup
        html={true}
        page={page}
        show={showExitPopup}
        defaultPrimaryLabel={exitPrimaryCtaLabel}
        defaultTitle={exitCtaLabel}
        defaultSecondaryLabel={exitSecondaryCtaLabel}
        keyProperty={keyProperty}
        defaultDescription={
          '<p>Are you sure you want to exit the flow? Your data will not be saved.<br /><br />\nDo you want to continue?</p>'
        }
        primaryCta={() => {
          setShowExitPopup(false);
          handleExitCta();
        }}
        secondaryCta={() => setShowExitPopup(false)}
      />
    </>
  );

  const showCancelModal = () => (
    <>
      <DrupalPopup
        html={true}
        page={page}
        show={showCancelPopup}
        defaultPrimaryLabel={'Continue'}
        defaultTitle={'Cancel'}
        defaultSecondaryLabel={'No, take me back'}
        keyProperty={keyPropertyUpdate}
        defaultDescription={
          '<p>Are you sure you want to exit the flow? Your data will not be saved.<br /><br />\nDo you want to continue?</p>'
        }
        primaryCta={() => {
          setShowCancelPopup(false);
          handleUpdateCancel();
        }}
        secondaryCta={() => setShowCancelPopup(false)}
      />
    </>
  );

  return (
    <>
      {edit ? (
        <ButtonWrapper>
          <FlowButtonContainer
            halfWidth={!cancelFitWidth}
            fitContent={cancelFitWidth}
          >
            <GeneralButton
              type="functional"
              inverted={true}
              width="150px"
              onClick={() => {
                enableCancelPopUp
                  ? setShowCancelPopup(true)
                  : handleUpdateCancel();
              }}
              id="btnFlowFooterEdit"
              text={updateCancelLabel}
            />
          </FlowButtonContainer>
          {handleUpdateCta && (
            <GrantPrimaryButtonWrapper mobHalfWidth>
              <FlowButtonContainer>
                <GeneralButton
                  type="functional"
                  mobWidth="100%"
                  width="150px"
                  disabled={!enableUpdate}
                  onClick={handleUpdateCta}
                  id="btnFlowFootUpdate"
                  text={updateCtaLabel}
                />
              </FlowButtonContainer>
            </GrantPrimaryButtonWrapper>
          )}
        </ButtonWrapper>
      ) : (
        <ButtonWrapper>
          <FlowButtonContainer btnWithMargin halfWidth>
            <GeneralButton
              type="functional"
              mobWidth="100%"
              inverted={true}
              width="150px"
              onClick={handleSecondaryCta}
              id="btnFlowFooterSecondary"
              text={secondaryCtaLabel}
            />
          </FlowButtonContainer>
          {showExitCta && (
            <FlowButtonContainer halfWidth>
              <GeneralButton
                type="functional"
                mobWidth="48%"
                inverted={true}
                width="150px"
                onClick={() => setShowExitPopup(true)}
                id="btnFlowFooterExit"
                text={exitCtaLabel}
              />
            </FlowButtonContainer>
          )}
          <GrantPrimaryButtonWrapper>
            {spin ? (
              <FlowButtonContainer>
                <GeneralButton
                  id="btnFlowFooterSpinner"
                  type="functional"
                  mobWidth="100%"
                  width="150px"
                  text={<Spinner />}
                />
              </FlowButtonContainer>
            ) : (
              <FlowButtonContainer>
                <GeneralButton
                  type="functional"
                  mobWidth="100%"
                  width="150px"
                  disabled={!enablePrimary}
                  onClick={handlePrimaryCta}
                  id="btnFlowFooterPrimary"
                  text={primaryCtaLabel}
                />
              </FlowButtonContainer>
            )}
          </GrantPrimaryButtonWrapper>
        </ButtonWrapper>
      )}
      {showExitModal()}
      {showCancelModal()}
    </>
  );
}

FlowFooter.propTypes = {
  primaryCtaLabel: PropTypes.string,
  handlePrimaryCta: PropTypes.func,
  secondaryCtaLabel: PropTypes.string,
  handleSecondaryCta: PropTypes.func,
  exitCtaLabel: PropTypes.string,
  handleExitCta: PropTypes.func,
  showExitCta: PropTypes.bool,
  enablePrimary: PropTypes.bool,
  enableUpdate: PropTypes.bool,
  edit: PropTypes.bool,
  spin: PropTypes.bool,
  handleUpdateCancel: PropTypes.func,
  updateCancelLabel: PropTypes.string,
  handleUpdateCta: PropTypes.func,
  updateCtaLabel: PropTypes.string,
  enableCancelPopUp: PropTypes.bool,
  exitPrimaryCtaLabel: PropTypes.string,
  exitSecondaryCtaLabel: PropTypes.string,
  cancelFitWidth: PropTypes.bool,
  page: PropTypes.string,
  keyProperty: PropTypes.string,
  keyPropertyUpdate: PropTypes.string,
};

export default FlowFooter;
